
import ComingSoon from "../components/comingSoon/ComingSoon";

const ContactUs = () => {
  return <ComingSoon/>;
};

export default ContactUs;
